<script lang="ts" setup>
const model = defineModel<any>();
const props = withDefaults(defineProps<{
    size?: 'sm' | 'md' | 'lg';
    fluid?: boolean;
}>(), {
    size: 'md',
    fluid: true
});

const size = computed<any>(() => props.size == 'md'
    ? null
    : props.size == 'sm'
        ? 'small'
        : 'large'
);
</script>

<template>
    <PrimeInputText v-model="model" :size="size" :fluid="props.fluid" />
</template>
